// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__zxbNM","header":"ReportDetails_header__1K9JM","title":"ReportDetails_title__2DA2E","left":"ReportDetails_left__RndcA"};